export const getNavigationPages = (
  projectId,
  isAdmin,
  adminPages,
  groupCoordinatorPages
) => {
  if (!projectId) {
    return [];
  }
  return isAdmin ? adminPages : groupCoordinatorPages;
};
